<template>
  <div class="container" style="position: relative">
    <div v-if="!ifLgScreen" style="position: absolute;top: 10px;width: 100%;padding: 0 20px;box-sizing: border-box;display: flex;justify-content: space-between">
      <div @click="hostname==hostUri?goBackOtherHome():$router.push('/')">
        <div>
          <img style="width: 22px;height: 22px; vertical-align: middle" src="../../assets/img/user/phone.svg" alt="">
          <span style="display: inline-block; vertical-align: middle">{{ $t('login.home_page') }}</span>
        </div>
      </div>
      <div @click="$router.push('../download')">
        <span style="display: inline-block; vertical-align: middle">{{ $t('footer.download_app') }}</span>
        <img style="width: 22px;height: 22px; vertical-align: middle; transform: scale(-1.0)" src="../../assets/img/user/phone.svg" alt="">
      </div>
    </div>

    <div v-else  style="position: absolute;top:10px;display: flex;justify-content: space-between;padding:0 2%;box-sizing:border-box;width: 100%">
      <img style="width: 110px; height: 30px; cursor: pointer" @click="hostname==hostUri?goBackOtherHome():$router.push('/')" src="../../assets/img/logo_purple.png" alt="">
      <div>
        <img src="" alt="">
        <span @click="hostname==hostUri?goBackOtherHome():$router.push('/')" style="color: #AB54DB;cursor: pointer">{{ $t('login.back_homepage') }}</span>
      </div>
    </div>
    <div class="login">
      <div class="title">{{ $t('login.reset_password') }}</div>
      <div class="tab">
        <div @click="isActive=true;$refs.registerFormRef.resetFields()" :class="{'bg-change':isActive}">{{ $t('login.email') }}</div>
<!--        <div @click="isActive=false;$refs.registerFormRef.resetFields()" :class="{'bg-change':!isActive}">{{ $t('login.mobile_phone') }}</div>-->
      </div>
      <div class="form">
        <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef" @keyup.enter.native="handleResetPassword">
          <div class="form-group">
            <div v-if="isActive">
              <div class="label">{{ $t('login.email') }}</div>
              <el-form-item prop="email">
                <el-input v-model="registerForm.email" :placeholder="$t('login.input_email_number')" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else style="position: relative">
              <div class="label">{{ $t('login.mobile_phone') }}</div>
              <el-form-item prop="phone">
                <el-input v-model="registerForm.phone"  :placeholder="$t('login.input_phone')" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group">
            <div class="label">{{ $t('login.authCode') }}</div>
            <el-form-item prop="auth_code"  style="position: relative">
              <el-input v-model="registerForm.auth_code" :placeholder="$t('login.input_code')"></el-input>
              <div class="auth-code" v-if="isActive">
                <div v-if="isEmailSent" @click="sendAuthCode('email')" style="font-size: 14px;font-weight: 400;color: #AB54DB;">{{ $t('login.send_code') }}</div>
                <div v-else><span>{{emailSeconds}}</span><span>{{ $t('login.resend_code') }}</span></div>
              </div>
              <div class="auth-code" v-else>
                <div v-if="isPhoneSent" @click="sendAuthCode('phone')" style="font-size: 14px;font-weight: 400;color: #AB54DB;">{{ $t('login.send_code') }}</div>
                <div v-else><span>{{phoneSeconds}}</span><span>{{ $t('login.resend_code') }}</span></div>
              </div>
            </el-form-item>
            <div class="label">{{ $t('login.password') }}</div>
            <el-form-item prop="password">
              <el-input v-model="registerForm.password" show-password :placeholder="$t('login.input_new_pwd')"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="btns">
          <button class="login-btn" @click="handleResetPassword">{{ $t('login.next_step') }}</button>
        </div>
      </div>
      <div class="links">
        <div class="register" @click="$router.push('/login')">{{ $t('login.login') }}?</div>
      </div>
    </div>
  </div>
</template>

<script>
import {checkEmail, checkEmailGeneral, checkMobile, checkMobileGeneral, checkPassword} from "../../utils/validate";
import {getAuthCode, resetPassword, toRegister} from "../../server/auth";
import {screenSize} from "../../utils/tools";

export default {
  name: "Forget_password",
  data(){
    return{
      isActive:true,
      registerForm:{
        email:'',
        phone:'',
        password:'',
        auth_code:'',
      },
      registerRules:{
        phone:[{ required: true, message: this.$t('login.input_phone'), trigger: 'blur' },
          {validator:checkMobile,trigger: 'blur'}],
        email:[{ required: true, message: this.$t('login.input_email'), trigger: 'blur' },
          {validator:checkEmail,trigger: 'blur'}],
        password:[{ required: true, message: this.$t('login.input_pwd'), trigger: 'blur' },
          {validator:checkPassword,trigger: 'blur'}],
        auth_code:[{ required: true, message: this.$t('login.input_code'), trigger: 'blur' }],
      },
      //  验证码的功能
      isPhoneSent:true,
      phoneSeconds:60,
      isEmailSent:true,
      emailSeconds:60,
      ifLgScreen:true,
      hostname: '',
      hostUri: this.$registered_address.host_uri()
    }
  },
  created() {
    // this.$i18n.locale='en'
    this.hostname = window.location.hostname
    this.ifLgScreen=screenSize(900)
  },
  methods:{
    //  发送数字验证码
    async sendAuthCode(kind){
      if (kind==='phone'){
        if (!checkMobileGeneral(this.registerForm.phone)||this.registerForm.area==='') return this.$message.error(this.$t('login.confirm_whether_phone_format_area_correct'))
        this.isPhoneSent=false
        const timer=setInterval(()=>{
          this.phoneSeconds--
          if (this.phoneSeconds===0){
            this.phoneSeconds=60
            this.isPhoneSent=true
            clearInterval(timer)
          }
        },1000)
        const res=await getAuthCode(2,2,this.registerForm.phone)
        if (!res.success) return this.$message.warning(res.message)
        if (res.success) this.$message.success(this.$t('login.code_sended_phone'))
      }
      else if (kind==='email'){
        if (!checkEmailGeneral(this.registerForm.email)) return this.$message.error(this.$t('login.input_right_email'))
        this.isEmailSent=false
        const timer=setInterval(()=>{
          this.emailSeconds--
          if (this.emailSeconds===0){
            this.emailSeconds=60
            this.isEmailSent=true
            clearInterval(timer)
          }
        },1000)
        const res=await getAuthCode(2,1,this.registerForm.email)
        if (!res.success) return this.$message.warning(res.message)
        if (res.success) this.$message.success(this.$t('login.code_sended_email'))
      }
    },
    handleResetPassword(){
      this.$refs.registerFormRef.validate( async valid=>{
        if(!valid) return this.$message.error(this.$t('login.confirm_entered_info_is_correct'))
        let username='';let acounttype=1
        const {email,phone,password,auth_code}=this.registerForm
        if (this.isActive) username = email
        else{username = phone;acounttype=2}
        const res = await resetPassword(acounttype,username,password,auth_code)
        if (res.success === false) return this.$message.error(res.message)
        this.$message.success(this.$t('login.password_setting_succeeded'))
        await this.$router.push('/login')
      })
    },
    goBackOtherHome(){
      window.location.replace('https://www.uplustrade.com/')
    }
  }
}
</script>

<style scoped>
.container{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title{
  font-size: 23px;
  font-weight: 600;
  color: #181E25;
  margin-bottom: 42px;
}
.tab div{
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  color: #181E25;
  height: 27px;
  line-height: 27px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.tab div:nth-child(1){
  width: 82px;
}
.tab div:nth-child(2){
  width: 140px;
}
.bg-change{
  /*background: #F5F5F5;*/
  color: #AB54DB !important;
}

.active{
  display: block;
}
.not-active{
  display: none;
}
.form .form-group .label{
  font-size: 14px;
  font-weight: 400;
  color: #181E25;
  margin: 26px 0 14px 0;
}
.form .form-group input{
  width: 325px;
  height: 46px;
  border-radius: 2px;
  border: 1px solid #979797;
}
.btns{
  display: flex;
  width: 100%;
  justify-content: center;
}
.login-btn{
  width: 329px;
  height: 51px;
  background: #AB54DB;
  border: none;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.5);
  border-radius: 5px;
  margin-top: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #FFFFFF;
  cursor: pointer;
  letter-spacing: 2px;
}
.links div{
  cursor: pointer;
}
.links {
  width: 200px;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  color: #1E4598;
  line-height: 20px;
}

.links div {
  cursor: pointer;
  color: #AB54DB;
}


.auth-code{
  position: absolute;
  top:0px;
  right: 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #8E9298;
}
.auth-code>div>span:first-child{
  font-size: 14px;
  font-weight: 400;
  color: #AB54DB;
  margin-right: 6px;
}
</style>
